import React from 'react';
import './WhatsAppButton.css';

const WhatsAppButton: React.FC = () => {
  const phoneNumber = '919660750779'; // Replace with actual business number
  const message = encodeURIComponent('Hi JK Prints, I want to place an order');
  
  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <button 
      className="whatsapp-button"
      onClick={handleClick}
      aria-label="Contact on WhatsApp"
    >
      <span className="icon-whatsapp"></span>
      <span className="whatsapp-text">Chat with us</span>
    </button>
  );
};

export default WhatsAppButton;
